"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Addon = void 0;
class Addon {
    constructor() {
        this.events = {};
    }
}
exports.Addon = Addon;
//# sourceMappingURL=addon.js.map